import './static.scss';
// import $ from 'jquery';
// import RoomsController from './components/Controllers/Rooms';
// import $ from 'jquery';
// var axios = require('axios');


console.log('static pages');

if (document.getElementById('register-form-email')) {

  document.getElementById('register-form-email').oninput = function () {
    // result.innerHTML = input.value;
    let emailAddress = document.getElementById('register-form-email').value;
    let firstPart = emailAddress.match(/^(.+)@/)[1];
    console.log(firstPart);
    document.getElementById('register-form-username').value = firstPart;
    console.log(document.getElementById('register-form-username').value);
  };
}



